<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain>
      <Loading v-if="loading" />
      <ChatPrincipal v-else />
    </InternaMain>
  </Wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import ChatPrincipal from '@/components/Chat/ChatPrincipal.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'Chat',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    ChatPrincipal,
    Loading,
  },

  props: {
    transacaoId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState(['dadosTransacao']),
  },

  created() {
    if (this.dadosTransacao.id !== this.transacaoId) {
      this.carregarTransacao();
    }
  },

  methods: {
    ...mapActions(['setDadosTransacao']),

    async carregarTransacao() {
      this.loading = true;

      await api.get(`order/${this.transacaoId}`)
        .then((response) => {
          this.setDadosTransacao(response.data);
        })
        .catch(() => {
          this.$router.push('/minhas-compras');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
